import { render, staticRenderFns } from "./Indications.vue?vue&type=template&id=5664defe&scoped=true&lang=pug"
import script from "./Indications.vue?vue&type=script&lang=js"
export * from "./Indications.vue?vue&type=script&lang=js"
import style0 from "./Indications.vue?vue&type=style&index=0&id=5664defe&prod&lang=scss&scoped=true"
import style1 from "./Indications.vue?vue&type=style&index=1&id=5664defe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5664defe",
  null
  
)

export default component.exports